import { rootApi } from "../../api/rootApi";

export const appBannerApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    addAppBanner: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: params.isMultiple ? `/tenant/appBanner/add-multiple` : `/tenant/appBanner/add`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    getAppBanner: builder.mutation({
      query: (params) => {
        let url = `/tenant/appBanner/`;
        if (params?.language) {
          url += `?language=${encodeURIComponent(params.language)}`;
        }
        return {
          method: "GET",
          url,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    deleteAppBanner: builder.mutation({
      query: (params) => {
        return {
          method: "DELETE",
          url: `/tenant/appBanner/${params.id}`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
  }),
});

export const { useAddAppBannerMutation, useGetAppBannerMutation,useDeleteAppBannerMutation } =
  appBannerApi;
